var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderMenuLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "#EA3C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMenuLine);
export default __webpack_public_path__ + "static/media/header-menu-line.13b4b588af3a649a590d25001c89c272.svg";
export { ForwardRef as ReactComponent };